import Vue from '@/vue';

document.addEventListener('DOMContentLoaded', () => {
  const App = new Vue();
  if (App) App.mount();
});
